import { Grid, Typography, Button } from "@mui/material";
import React from "react";
import arrow from '../image/sample/arrow.png';
import { useParams, NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useEffect } from "react";
import borderDesc from '../image/sample/borderDesc.png';
import { useState } from "react";
import shadow from '../image/sample/shadow.png';
import Footer from "./Footer";
import mockupLoptop from '../image/sample/mockupLoptop.png';
import mockupTablet from '../image/sample/mockupTablet.png';
import mockupMobile from '../image/sample/mockupMobile.png';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import '../styles/WorkSample.css';
import '../styles/WorkSample.css';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/css/pagination';
import '../styles/WorkSample.css';
import 'swiper/css/navigation';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import TabletMacOutlinedIcon from '@mui/icons-material/TabletMacOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import { setCanonicalTag } from "./modules/general";
import { dataTravel, dataAmozeshi, dataDesign, dataPezeshki, dataFood } from "./DataSample";
import Loader from "./Loader";
import ModalLogin from "./ModalLogin";
SwiperCore.use([Navigation, Autoplay]);

const TempeleteSample = ({ auth }) => {
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const [slides, setSlides] = useState("1");
  const [slideMode, setSildeMode] = useState("pc");
  const [dataTempelete, setDataTempelete] = useState(null)
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const Navigate = useNavigate();


  const params = useParams();

  useEffect(() => {
    let type = params.type;
    let title = "";
    let description = ""
    let keywords = ""
    switch (type) {
      case ("Designing"):
        title = "وب سایت معماری و ساختمان شرکت سورین | طراحی سایت وب معماری و طراحی داخلی گستران سورین"
        description = "قالب Designing  شرکت وب گستران سورین مناسب برای وب سایت های صنعت ساختمان از جمله طراحی داخلی ساختمان، طراحی نما، بازسازی خانه، مشارکت در ساخت و ... بسیار مناسب است"
        keywords = "نمونه پروژه های سورین | بهترین قالب سایت | نمونه وب سایت معماری | نمونه وب سایت فروشگاهی | نمونه وب سایت شرکتی | نمونه وب سایت پزشکی | نمونه وب سایت رستوران | نمونه وب سایت بازی | نمونه وب سایت خبری"
        break;
      case ("Food"):
        title = "وب سایت کافه و غذا شرکت سورین | طراحی وب سایت رستوران |"
        description = "قالب Food شرکت وب گستران سورین مناسب برای مارکت پلیس های رستورانی مانند اسنپ فود می باشد. قابلیت شخصی سازی قالب برای رستوران ها، کافی شاپ ها و ابمیوه فروشی ها وجود دارد"
        keywords = "وب سایت آنلاین سفارش غذا | سایت خرید غذا از رستوران ها | سایت سفارش کافه از کافی شاپ |"
        break;
      case ("Travel"):
        title = "وب سایت مسافرتی | وب سایت گردشگری | وب سایت معرفی مکان های دیدنی | وب سایت رزور بلیط و هتل "
        description = "قالب Travel  وب گستران سورین برای آژانس های مسافرتی و شرکت های ارایه کننده مشاوره و راهنمایی مسافران داخل و خارج از کشورمناسب است. همچنین پلتفرم مقایسه نرخ بلیط و هتل هم میتواند از قالب فوق استفاده کند."
        keywords = "وب سایت آژانس های مسافرتی | پلتفرم اجاره ویلا | سایت خرید بلیط هواپیما | سایت گردش و سفر | وب سایت تور مسافرتی | سایت مشاوره به مسافران"
        break;
      case ("Educational"):
        title = "وب سایت آموزش آنلاین | وب سایت آموزشگاهی | سایت آموزش مجازی"
        description = "قالب Educational  شرکت وب گستران سورین برای آموزشگاه ها و موسسات آموزشی نطیر فرادرس بسیار مناسب است. هم برای دانشگاه ها و هم مدارس آموزش مجازی قابل استفاده می باشد"
        keywords = "وب سایت آموزش از راه دور | وب سایت دانشگاهی | سایت آموزشی |وب سایت دوره های آنلاین | وب سایت یادگیری | سایت آموزش آنلاین درسی"
        break;
      case ("Medical"):
        title = "وب سایت پزشکی | وب سایت نوبت دهی اینترنتی | وب سایت تندرستی و سلامت | وب سایت تخصصی سلامت | وب سایت زیبایی | وب سایت دندانپزشکی |"
        description = "قالب Medical شرکت وب گستران سورین مناسب فعالیت های مربوط به سلامت می باشد. سایت نوبت دهی، سایت معرفی پزشکان، سایت بیمارستانی و هرگونه خدمات آنلاین پزشکی که قابل ارایه در محیط اینترنت را داراست"
        keywords = "وب سایت زیبایی | سایت تخخصصی پزشکی |سایت خدمات آنلاین پزشکی | سایت آنلاین خدمات سلامتی | سایت بیمارستان و مرکز درمانی | سایت داروخانه | سایت آزمایشکاه | وب سایت ژورنال پزشکی |سایت تجهیزات پزشکی"
        break;
      case ("Technology"):
        title = "وب سایت تکنولوژی | سایت فناوری نوین | وب سایت آی تی |وب سایت فناوری اطلاعات | سایت واقعیت مجازی | سایت بر بستر بلاکچین | سایت تکنولوژی نرم افزار | سایت تکنولوژی سخت افزار  "
        description = "قالب Technology شرکت وب گستران سورین مناسب کسب و کار های فناوری اطلاعات و تکنولوژی می باشد. وب سایت هایی که خدماتی نظیر اخبار حوزه تکنولوژی، معرفی سخت افزار و دستگاههای دیجیتال، هوش مصنوعی، فناوری بلاکچین و هر خدمت و محصولی که در حوزه تکنولوژی جا گیرد، میتوانند از این قالب استفاده نمایند."
        keywords = "وب سایت خدمات تکنولوژی | بهترین سایت حوزه تکنولوژی | سایت هوش مصنوعی | سایت خدمات "
        break;
      case ("Financial"):
        title = "سایت مالی و حسابداری | نرم افزار حسابداری | سایت تخصصی مالی | وب گستران سورین "
        description = "قالب Financial  شرکت وب گستران سورین مناسب برای انواع سایتهای حوزه مالی و حسابداری می باشد. استارآپ های فین تک و وب سایتهای که تحلیل و یا خدمات مالی ارایه می دهند، میتوانند از این قالب استفاده کنند."
        keywords = "وب سایت تحلیل تکنیکال | سایت های بورسی | سایت ارز دیجیتال | صرافی رمزارز | سایت کیف پول آنلاین | سایت مشابه تردینگ ویو | سایت بازار سرمایه"
        break;
      case ("PicVideoMusic"):
        title = "سایت تماشا و دانلود فیلم | سایت اشتراک گذاری فیلم و عکس | سایت دانلود و پخش موزیک | وب گستران سورین"
        description = "قالب picVideoMusic  شرکت وب گستران سورین برای انواع وب سایت فعال در زمینه دانلود و پخش موزیک، فیلم، سریال، انیمیشن و مناسب است . هم چنین سایت های فعال در زمینه طراحی و ادیت عکس و هم چنین اشتراک گذاری فایل صوتی و تصویری می توانند از این قالب استفاده کنند. "
        keywords = "سایت دانلود عکس | سایت دانلود و تماشای آنلاین فیلم و سریال |  سایت | سایت ادیت عکس و فیلم | سایت موزیک ساز | سایت دانلود و خرید موسیقی | سایت دانلود آهنگ |"
        break;
      case ("BeautyAndHealth"):
        title = "سایت سلامت و تندرستی | سایت زیبایی و پوست | سایت بهداشت عمومی | وب گستران سورین"
        description = "قالب BeautyAndHealth  شرکت وب گستران سورین برای وب سایت های فروشگاهی که وسایل بهداشتی بفروش می رسانند مناسب است. هم چنین خدمات زیبایی نظیر کلینیک و آرایشگاه ها هم میتوانند از این قالب استفاده کنند"
        keywords = "وب سایت آرایشی و بهداشتی | وب سایت سلامت پوست | وب سایت سالن زیبایی | سایت آرایشگاه زنانه"
        break;
      case ("Business"):
        title = "سایت کسب و کار | سایت استارت آپ | وب سایت مشاغل خانگی | وب گستران سورین"
        description = "قالب Business شرکت وب گستران سورین مناسب برای کسب و کار های تازه تاسیس و کسب و کارهای کوچک یا خانگی مناسب است. هم چنین برای معرفی خدمات یا شرکت شما این قالب قابل به بهینه سازی برای انواع شرکت می باشد."
        keywords = "وب سایت کسب و کارهای کوچک | وب سایت شرکتی | سایت معرفی شرکت | سایت"
        break;
      case ("Marketing"):
        title = "وب سایت فروشگاهی | فروشگاه اینترنتی | وب سایت آنلاین فروشگاهی | سایت فروش اینترنتی آنلاین"
        description = "قالب فروشگاهی Marketing  وب گستران سورین برای انواع فروشگاههای اینترنتی مناسب است. کسب و کارهای که در زمینه فروش هر نوع کالا فعالیت دارند، میتوانند از قالب esor  استفاده کنند. هم چنین این قالب برای انواع مارکت پلیس و فروشگاههای آنلاین با هر حجم محصولاتی قابل استفاده می باشد."
        keywords = "سایت خرید اینترنتی | سایت درگاه پرداخت | سایت فروش آنلاین | پلتفرم خرید و فروش اینترنتی | سایت مارکت پلیس فروشگاهی | "
        break;
      case ("ECommerce"):
        title = "سایت بازاریابی اینترنتی | سایت تبلیغات آنلاین |  پلتفرم تبلیغات اینترنتی | وب گستران سورین "
        description = "قالب ECommerce شرکت وب گستران سورین برای وب سایت هایی که به عنوان نمایش دهنده تبلیغات محسوب می شوند و کسب و کار های بازاریابی که درخواست پلتفرم با قابلیت های تبلیغات کلیکی، تبلیغات بنری، تبلیغات ریتارگتینگ، رپرتاژ آگهی و ...دارند، می توئانند استفاده کنند."
        keywords = "سامانه تبلیغات اینترنتی | سایت تبلیغات کلیکی | وب سایت بازاریابی آنلاین | سایت رپرتاژ آگهی | سایت دیجیتال مارکتینگ | سایت درج تبلیغات اینترنتی | سایت تبلیغات هوشمند"
        break;
      case ("Entertainmentgame"):
        title = "سایت تخصصی بازی | سایت بازی آنلاین | وب سایت سرگرمی اینترنتی | وب گستران سورین"
        description = "قالب Entertainmentgame شرکت وب گستران سورین برای کسب و کارهایی که در حوزه بازی و سرگرمی فعالیت می کنند بسیار کاراست. هم چنین این قالب برای پیش بینی و سایت های کازینو قابل پیاده سازیست."
        keywords = "سایت بازی کوکان | سایت بازی بزرگسالان | سایت سرگرمی و شادی | سایت طنز و خنده | اپلیکیشن بازی موبایل | سایت بازی رایانه ای | سایت داستان و سرگرمی"
        break;
      case ("Blog"):
        title = "وب سایت شخصی | سایت مجله اینترنتی | وب سایت مجله آنلاین"
        description = "قالب Blog  شرکت وب گستران سورین برای کسب و کارهایی که در زمینه اخبار، مقالات، آموزش فعال هستند مناسب است. هم چنین از این قالب می توان به عنوان سایت یا یلاگ شخصی هم استفاده کرد. پلتفرم های انتشار محتوا می توانند با شخصی سازی قالب فوق به راحتی فعالیت داشته باشند."
        keywords = "سایت آنلاین اطلاعات | وب لاگ اینترنتی | سایت انتشار مقالات و اخبار و آموزش | سایت دانلود مقالات"
        break;
    }

    document.title = title
    document.getElementById("main-heading").innerHTML = title
    document.getElementsByTagName('meta')["description"].content = description;
    document.getElementsByTagName('meta')["keywords"].content = keywords
    document.getElementsByTagName('meta')["author"].content = "شرکت وب گستران سورین";
    setCanonicalTag()
  }, []);

  useEffect(() => {
    setSlidesPerview();
    window.addEventListener("resize", setSlidesPerview);
    return () => {
      window.removeEventListener("resize", setSlidesPerview);
    };
  }, []);

  useEffect(() => {
    let data = []
    let dataList = null
    let type = params.type;
    data = type === "Designing" ? dataDesign : type === "Food" ? dataFood : type === "Travel" ? dataTravel : type === "Educational" ? dataAmozeshi : type === "Medical" && dataPezeshki;
    data.forEach((item) => {
      if (item.title === params.title) dataList = item
      setLoading(false)
    })
    setDataTempelete(dataList)
  }, [])

  const setSlidesPerview = () => {
    setSlides(
      window.innerWidth <= 600
        ? 1
        : window.innerWidth <= 900
          ? 2
          : window.innerWidth > 720
            ? 3
            : 0
    );
  }

  const handleCloseModal = () => {
    setOpen(false);
  }

  const loginHandler = () => {
    setType("L");
    setOpen(true);
  }
  const orderSite = () => {
    let info = JSON.parse(localStorage.getItem('sorinInfoUser'));
    auth === false ? loginHandler() : info.user_type_id !== null && info.user_type_id === 1 || info.user_type_id !== null && info.user_type_id === 2 ? Navigate(`/SorinBoard/WebsiteOrder`) : Navigate("/SorinBoard/NewOrder");
  }
  return (
    <>
      <Grid sx={{ display: "flex", flexDirection: 'column', width: "100%", direction: i18n.language === "fa" ? "rtl" : "ltr", alignItems: "center" }}>
        <Grid sx={{ display: "flex", width: "100%", backgroundColor: "#EDEDED", padding: "15px 0", justifyContent: "center" }}>
          <Grid sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", width: { xs: "95%", md: "86%" } }}>
            <NavLink className="navlink" to="/">
              <Typography component={"p"} sx={{ fontSize: "12px", color: "#757575", padding: { xs: "0 2px", sm: "0 5px" } }} >{t("mainPage")}</Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <NavLink className="navlink" to="/Portfolio">
              <Typography component={"p"} sx={{ fontSize: "12px", color: "#757575", padding: { xs: "0 2px", sm: "0 5px" } }}>{t("sampleWork")}</Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <NavLink className="navlink" to={`/Portfolio/${params.type}`}>
              <Typography component={"p"} sx={{ fontSize: "12px", color: "#757575", padding: { xs: "0 2px", sm: "0 5px" } }}>{t("sites")} {t(params.type)}</Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <Typography component={"p"} sx={{ fontSize: "12px", color: "#070707", padding: { xs: "0 2px", sm: "0 5px" } }}>{t(params.title)}</Typography>
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", alignItems: "flex-end", justifyContent: 'flex-start', flexDirection: 'row', width: { xs: "95%", md: "86%" }, margin: "30px 0" }}>
          <Typography component={"img"} alt="arrow" src={arrow} sx={{
            width: { xs: "19px", sm: "29px" }, height: { xs: "24px", sm: "37px" }, filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
            padding: "0 3px", transform: i18n.language === "en" && "rotate(180deg)"
          }} />
          <Typography sx={{ fontSize: { xs: "16px", sm: "20px", md: "24px" }, color: "#070707", fontWeight: "700" }}>{t(params.title)}</Typography>
        </Grid>
        {
          loading === false && dataTempelete !== null ?
            <Grid sx={{ display: "flex", alignItems: 'center', flexDirection: "column", width: "100%" }}>
              <Grid sx={{
                display: "flex", alignItems: 'center', justifyContent: 'cnter', backgroundSize: "100% 100%", backgroundImage: `url(${dataTempelete.mockup})`, backgroundPosition: "center",
                backgroundRepeat: "no-repeat", width: { xs: "272px", sm: "584px", md: "850px", lg: "987px" }, height: { xs: "158px", sm: "343px", md: "480px", lg: "582px" }
              }}>
              </Grid>
              <Grid sx={{ display: "flex", alignItems: "flex-start", justifyItems: "flex-start", width: { xs: "272px", sm: "584px", md: "850px", lg: "987px" }, marginTop: "15px" }}>
                <Grid sx={{
                  display: "flex", alignItems: 'center', justifyContent: 'center', backgroundSize: "100% 100%", backgroundImage: `url(${borderDesc})`, backgroundPosition: "center",
                  backgroundRepeat: "no-repeat", width: { xs: "73px", sm: "112px" }, height: { xs: "31px", sm: "47px" }
                }}>
                  <Typography sx={{ fontSize: { xs: "12px", sm: "20px" }, color: "#070707" }}>{t("Description")}</Typography>
                </Grid>
              </Grid>
              <Grid sx={{
                display: "flex", alignItems: "center", justifyItems: "center", width: { xs: "272px", sm: "584px", md: "850px", lg: "987px" }
                , boxShadow: "0px 4px 8px rgba(81, 74, 75, 0.5)", background: "#FFFFFF", padding: { xs: "15px 10px", md: "20px 15px" }
              }}>
                <Typography sx={{ fontSize: { xs: "12px", sm: "14px", md: "16px" }, color: "#070707" }}>{dataTempelete.desc}</Typography>
              </Grid>
              <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', margin: "30px 0" }}>
                <Button onClick={orderSite} sx={{
                  width: { xs: "120px", sm: "190px", md: "220px" }, height: { xs: "35px", sm: "41px" }, background: "#FF3951", boxShadow: "0px 0px 8px #FF3951",
                  borderRadius: "8px", color: "#FFFFFF", fontSize: { xs: "10px", sm: "16px" }, "&:hover": { background: "#FF3951" }
                }}>
                  {t("WebsiteOrder")}
                </Button>
              </Grid>
              <Grid sx={{
                display: "flex", alignItems: 'center', justifyContent: 'center', backgroundSize: "100% 100%", backgroundImage: `url(${shadow})`, backgroundPosition: "center", flexDirection: "column",
                backgroundRepeat: "no-repeat", width: "100%", height: { xs: "220px", sm: "491px", md: "750px", lg: "650px" }, margin: { xs: "50px 0", md: "100px 0 0 0" }, position: "relative"
              }}>
                <Grid sx={{
                  display: slideMode === "pc" ? "flex" : "none", alignItems: 'center', justifyContent: 'center', background: "transparent",
                  width: "100%", height: { xs: "220px", sm: "491px", md: "750px", lg: "600px" }, margin: { xs: "50px 0", md: "50px 0" }, position: "relative", flexDirection: "row"
                }}>
                  <Swiper
                    slidesPerView={3}
                    centeredSlides={true}
                    spaceBetween={30}
                    autoplay={{ delay: 3000, disableOnInteraction: false, reverseDirection: true, waitForTransition: true }}
                    className="mySwiper swiperSorinMag"
                    navigation
                  >
                    {dataTempelete.loptop !== undefined && dataTempelete.loptop.map((item, index) => (
                      <SwiperSlide className="slideSwiper" key={index}>
                        <Typography component={"img"} src={item} className="sliderLoptop" alt="img-portfolio"
                          sx={{
                            minWidth: { xs: "180px", sm: "400px", md: "505px", lg: "670px", xl: "660px" }, height: { xs: "110px", sm: "245px", md: "318px", lg: "410px", xl: "410px" }
                          }} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "center", zIndex: "100", position: "absolute", overflow: "hidden", top: { xs: "-1px", sm: "58px", md: "150px", lg: "50px" } }}>
                    <Typography component={"img"} src={mockupLoptop} alt="img-mockup" sx={{ width: { xs: "230px", sm: "510px", md: "650px", lg: "850px" } }} />
                  </Grid>
                </Grid>
                <Grid sx={{
                  display: slideMode === "tablet" ? "flex" : "none", alignItems: 'center', justifyContent: 'center', background: "transparent",
                  width: "100%", height: { xs: "220px", sm: "491px", md: "750px", lg: "600px" }, margin: { xs: "50px 0", md: "50px 0" }, position: "relative", flexDirection: "row"
                }}>
                  <Swiper
                    slidesPerView={3}
                    centeredSlides={true}
                    spaceBetween={-50}
                    autoplay={{ delay: 3000, disableOnInteraction: false, reverseDirection: true, waitForTransition: true }}
                    className="mySwiper swiperSorinMag"
                    navigation
                  >
                    {
                      dataTempelete.tablet !== undefined &&
                      dataTempelete.tablet.map((item, index) => (
                        <SwiperSlide className="slideSwiper" key={index}>
                          <Typography component={"img"} alt="img-portfolio" src={item} sx={{ width: { xs: "139px", sm: "310px", md: "430px", lg: "375px" }, minWidth: { xs: "139px", sm: "310px", md: "430px", lg: "375px" }, height: { xs: "195px", sm: "425px", md: "580px", lg: "535px" }, borderRadius: { xs: "5px", sm: "15px", md: "15px !important" } }} />
                        </SwiperSlide>
                      ))}
                  </Swiper>
                  <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "center", zIndex: "100", position: "absolute", overflow: "hidden" }}>
                    <Typography component={"img"} alt="img-mockup" src={mockupTablet} sx={{ width: { xs: "149px", sm: "330px", md: "450px", lg: "395px" }, }} />
                  </Grid>
                </Grid>
                <Grid sx={{
                  display: slideMode === "mobile" ? "flex" : "none", alignItems: 'center', justifyContent: 'center', background: "transparent",
                  width: "100%", height: { xs: "220px", sm: "491px", md: "750px", lg: "600px" }, margin: { xs: "50px 0", md: "50px 0" }, position: "relative", flexDirection: "row"
                }}>
                  <Swiper
                    slidesPerView={3}
                    centeredSlides={true}
                    spaceBetween={-50}
                    autoplay={{ delay: 3000, disableOnInteraction: false, reverseDirection: true, waitForTransition: true }}
                    className="mySwiper swiperSorinMag"
                    navigation
                  >
                    {dataTempelete.mobile &&
                      dataTempelete.mobile.map((item, index) => (
                        <SwiperSlide className="slideSwiper" key={index}>
                          <Typography component={"img"} alt="img-portfolio" src={item} sx={{ width: { xs: "85px", sm: "170px", md: "230px", lg: "250px" }, height: { xs: "170px", sm: "353px", md: "470px", lg: "520px" }, borderRadius: { xs: "15px", sm: "20px", md: "30px" } }} />
                        </SwiperSlide>
                      ))
                    }
                  </Swiper>
                  <Grid sx={{ display: "flex", alignItems: "center", justifyContent: "center", zIndex: "100", position: "absolute", overflow: "hidden" }}>
                    <Typography component={"img"} alt="img-mockup" src={mockupMobile} sx={{ width: { xs: "90px", sm: "190px", md: "250px", lg: "270px" } }} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "row", width: "100%", marginBottom: "50px", zIndex: "200" }}>
                <DesktopWindowsOutlinedIcon onClick={() => setSildeMode("pc")}
                  sx={{
                    color: slideMode === "pc" ? "#FF3951" : "#000000", fontSize: { xs: "25px", sm: '35px', md: "45px" }, padding: "0 5px",
                    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.35))", cursor: "pointer"
                  }} />
                <TabletMacOutlinedIcon onClick={() => setSildeMode("tablet")}
                  sx={{
                    color: slideMode === "tablet" ? "#FF3951" : "#000000", fontSize: { xs: "25px", sm: '35px', md: "45px" }, padding: "0 5px",
                    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.35))", cursor: "pointer"
                  }} />
                <PhoneIphoneOutlinedIcon onClick={() => setSildeMode("mobile")}
                  sx={{
                    color: slideMode === "mobile" ? "#FF3951" : "#000000", fontSize: { xs: "25px", sm: '35px', md: "45px" }, padding: "0 5px",
                    filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.35))", cursor: "pointer"
                  }} />
              </Grid>
            </Grid>
            :
            <Loader />
        }

      </Grid>
      <Footer />
      <ModalLogin open={open} close={handleCloseModal} data={type} />
    </>
  )
}

export default TempeleteSample;